import Grid from '@mui/material/Grid2';
import React from 'react';

import {Button, Divider, Stack} from '@mui/material';
import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {ChangeFlowVariantEnum} from 'presentation/modules/booking/shared/ui/components/ChangeFlowDialog/constants';
import {UnitCard} from 'presentation/modules/booking/shared/ui/components/UnitCard';
import {UnitNetworkHeader} from 'presentation/modules/booking/shared/ui/components/UnitNetworkHeader';
import {translations} from 'presentation/translations-new';
import {useExamUnitsAccreditedNetwork} from './hooks/useExamUnitsAccreditedNetwork';
import {ExamUnitsAccreditedNetworkProps} from './types';

const {accreditedNetwork, changeAppointmentLocal} =
	translations['pt-br'].privateFlow.bookingFlow.unitsFlow;

export function ExamUnitsAccreditedNetwork({unitsList}: ExamUnitsAccreditedNetworkProps) {
	const {
		isMobile,
		specialtyName,
		query,
		handleChangeModals,
		hideDivider,
		listIsEmpty,
		shouldReverseNetworkOrder,
	} = useExamUnitsAccreditedNetwork(unitsList);

	if (listIsEmpty) {
		if (query) return null;

		return (
			<Stack gap={2}>
				{hideDivider || shouldReverseNetworkOrder ? null : <Divider sx={{mt: 1}} />}

				<UnitNetworkHeader
					title={accreditedNetwork.title}
					description={accreditedNetwork.emptyDescription}
				/>
				<Button
					variant="outlined"
					sx={{width: isMobile ? '100%' : '330px', ml: 'auto'}}
					size="large"
					onClick={() => handleChangeModals(ChangeFlowVariantEnum.LOCATION)}
					data-tag-id={AppointmentBookingEnum.CLICK_ALTERAR_LOCAL_DE_ATENDIMENTO}>
					{changeAppointmentLocal}
				</Button>

				{hideDivider || !shouldReverseNetworkOrder ? null : <Divider sx={{mt: 1}} />}
			</Stack>
		);
	}

	return (
		<Stack gap={2}>
			{hideDivider || shouldReverseNetworkOrder ? null : <Divider sx={{mt: 1}} />}

			<UnitNetworkHeader
				title={accreditedNetwork.title}
				description={accreditedNetwork.phoneScheduleDescription}
			/>

			<Grid container spacing={2}>
				{unitsList?.units?.unitsSupportAccredited?.map((unit, index) => {
					return (
						<Grid
							key={`${unit.name}-${unit.formattedAddress}${index}`}
							size={{xs: isMobile ? 12 : 6}}>
							<UnitCard
								query={query}
								isNotSelf={true}
								onClick={() => {}}
								unitName={unit?.name}
								address={unit?.formattedAddress}
								nmBairroOrigem={unit?.nmBairroOrigem}
								isTelemedicine={false}
								distanceReference={unit?.distance}
								showDistanceReference={true}
								specialtyName={specialtyName}
								phoneNumbers={unit?.phoneNumbers}
							/>
						</Grid>
					);
				})}
			</Grid>

			{hideDivider || !shouldReverseNetworkOrder ? null : <Divider sx={{mt: 1}} />}
		</Stack>
	);
}
